import { useCallback } from 'react'
import { usePersistedState } from '../api/localStore'

const STORAGE_KEY = 'advanced.dashboard.customizeBarOpen'

export const useCustomizeBarOpen = (): [boolean, () => void] => {
  const [open, setOpen] = usePersistedState(STORAGE_KEY, true)
  const toggle = useCallback(() => setOpen((current) => !current), [setOpen])

  return [open, toggle]
}
